<template>
    <eventi-list-component :utente="utente" :key="keyListaEventi" :titoloEvento="titoloEvento"
        :pathEventResource="pathEventResource" :linkEvent="linkEvent"  :gruppo="gruppo" :tipoEvento="tipoEvento">
    </eventi-list-component>
</template>

<script>
import EventiListComponent from "../../../base/components/EventiListComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: {
        EventiListComponent,
    },

    watch: {
        utente: function () {
            this.keyListaEventi++;
        },
    },
    mounted() { },
    data() {
        return {
            titoloEvento: "Refertazione Ecocardio",
            pathEventResource: "/cardioecocardirefertazioni",
            keyListaEventi: 0,
            linkEvent: "/paziente/cardiologia/refertazioneecocardio",
            gruppo: "CARDIOLOGIA",
            tipoEvento: "ECOCARDIO REFERTAZIONI",
        };
    },
};
</script>

<style>

</style>
